// extracted by mini-css-extract-plugin
export default {"cardBoxSty":"UnitCoFactoryWide_cardBoxSty__x7JaR","tabsStyle":"UnitCoFactoryWide_tabsStyle__vQxrV","charts_wrapper":"UnitCoFactoryWide_charts_wrapper__wJHGP"};